import "./App.css";
import { ScpContainer } from "./ScpContainer";

function App() {
  return <ScpContainer />;
}

export default App;